import { render, staticRenderFns } from "./OrderFlowKitchenPage.vue?vue&type=template&id=2e49a3d3&scoped=true&"
import script from "./OrderFlowKitchenPage.vue?vue&type=script&lang=js&"
export * from "./OrderFlowKitchenPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49a3d3",
  null
  
)

export default component.exports